import React from 'react';
import '../../styles/components/ArchivedToggle.css';

interface ArchivedToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** What the switch is called, for lists that say "Archived" in another word. */
  label?: string;
  className?: string;
}

/**
 * The one control for reaching archived records: off shows active records,
 * on shows archived ones. Lives in the breadcrumb actions row of every list.
 * A real switch (role, aria-checked, visible label) so keyboard and screen
 * reader users get the same one-step control.
 */
export const ArchivedToggle: React.FC<ArchivedToggleProps> = ({ checked, onChange, label = 'Archived', className = '' }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    className={`archived-toggle${checked ? ' archived-toggle--on' : ''}${className ? ` ${className}` : ''}`}
    onClick={() => onChange(!checked)}
    title={checked ? 'Showing archived. Click to show active.' : 'Click to show archived.'}
  >
    <span className="archived-toggle__track" aria-hidden="true">
      <span className="archived-toggle__thumb" />
    </span>
    <span className="archived-toggle__label">{label}</span>
  </button>
);

export default ArchivedToggle;
